<template>
  <div id="app">
    <home></home>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
    home: () => import("../src/views/Home.vue")
  }
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
  background: #161616;
}
</style>
